import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "hg-folios";

const readFolios = () => JSON.parse(localStorage.getItem(KEY) || "[]");
const saveFolios = (f) => localStorage.setItem(KEY, JSON.stringify(f));

export const useCases = () => {
  const [cases, setCases] = useState([]);

  const refresh = useCallback(async () => {
    const folios = readFolios();
    if (!folios.length) return setCases([]);
    const { data } = await axios.get(`${API}/cases`, { params: { folios: folios.join(",") } }).catch(() => ({ data: [] }));
    setCases(data);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const track = (folio) => {
    const f = readFolios();
    if (!f.includes(folio)) saveFolios([folio, ...f]);
  };

  const create = async (payload) => {
    const { data } = await axios.post(`${API}/cases`, payload);
    track(data.folio);
    setCases((c) => [data, ...c]);
    return data;
  };

  const updateStatus = async (folio, status) => {
    const { data } = await axios.patch(`${API}/cases/${folio}`, { status });
    setCases((c) => c.map((x) => (x.folio === folio ? data : x)));
    return data;
  };

  const setAppointment = async (folio, payload) => {
    const { data } = await axios.put(`${API}/cases/${folio}/appointment`, payload);
    setCases((c) => c.map((x) => (x.folio === folio ? data : x)));
    return data;
  };

  const lookup = async (folio) => {
    const { data } = await axios.get(`${API}/cases/${folio.trim()}`);
    track(data.folio);
    setCases((c) => [data, ...c.filter((x) => x.folio !== data.folio)]);
    return data;
  };

  const forget = (folio) => {
    saveFolios(readFolios().filter((f) => f !== folio));
    setCases((c) => c.filter((x) => x.folio !== folio));
  };

  return { cases, create, updateStatus, setAppointment, lookup, forget };
};
